import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule as AngularFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

// Field Components
import { FormTextFieldComponent } from './fields/text-field.component';
import { FormSelectOneFieldComponent } from './fields/select-one-field.component';
import { FormSelectMultipleFieldComponent } from './fields/select-multiple-field.component';
import { FormFileUploadFieldComponent } from './fields/file-upload-field.component';
import { FormPictureUploadFieldComponent } from './fields/picture-upload-field.component';

// Renderer Component
import { FormRendererComponent } from './renderer/form-renderer.component';

// List and Details Components
import { FormListComponent } from './list/form-list.component';
import { FormDetailsComponent } from './details/form-details.component';


// Test Component
import { FormsTestComponent } from './forms-test.component';

// Services
import { FormService } from './service/form.service';
import { FormResponseService } from './service/form-response.service';
import { FormValidationService } from './service/form-validation.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AngularFormsModule,
    DragDropModule,
    FormTextFieldComponent,
    FormSelectOneFieldComponent,
    FormSelectMultipleFieldComponent,
    FormFileUploadFieldComponent,
    FormPictureUploadFieldComponent,
    FormRendererComponent,
    FormListComponent,
    FormDetailsComponent
  ],
  providers: [
    FormService,
    FormResponseService,
    FormValidationService
  ],
  exports: [
    FormTextFieldComponent,
    FormSelectOneFieldComponent,
    FormSelectMultipleFieldComponent,
    FormFileUploadFieldComponent,
    FormPictureUploadFieldComponent,
    FormRendererComponent,
    FormListComponent,
    FormDetailsComponent
  ]
})
export class FormsModule { }
